import { AdminMessage } from "@components/admin/admin-helpers"
import { SlideTimerIndicator } from "@components/atoms/SlideTimerIndicator"
import { useSlideTimer } from "@hooks/useSliderTimer"
import { useDrag, useGesture } from "@use-gesture/react"
import { defineBlock } from "eddev/blocks"
import { AnimatePresence, motion } from "motion/react"

export const meta: BlockMeta = {
  title: "Film Quotes",
  icon: "editor-quote",
  tags: ["film-text"],
  description: "Displays film quotes from Ferve.",
  category: "embed",
  conditions: {
    multiple: false,
  },
}

export default defineBlock("film/film-quotes", (props) => {
  const quotes = props.film?.filmInfo?.quote

  if (!quotes?.length) {
    if (env.admin) {
      return <AdminMessage>No quotes to show</AdminMessage>
    }
    return null
  }

  const slider = useSlideTimer({
    total: quotes.length,
    enabled: true,
    slideDuration: 6,
  })

  const swipe = useDrag(
    (e) => {
      const dir = e.swipe[0]
      if (dir === 1) {
        slider.goPrev()
      } else if (dir === -1) {
        slider.goNext()
      }
    },
    {
      axis: "x",
    },
  )

  const slides = quotes.map((quote, index) => {
    return (
      <div key={index} className="flex flex-col gap-3 w-full flex-none">
        <motion.div
          className="type-body-m relative"
          variants={{ exit: { opacity: 0, y: 5 }, enter: { opacity: 1, y: 0 } }}
        >
          <span className="absolute right-full">“</span>
          <span dangerouslySetInnerHTML={{ __html: quote?.text! }} />
          <span>”</span>
        </motion.div>
        <motion.div
          className="type-label-caps text-fg-secondary"
          dangerouslySetInnerHTML={{ __html: quote?.author! }}
          variants={{ exit: { opacity: 0, y: 5 }, enter: { opacity: 1, y: 0 } }}
        />
      </div>
    )
  })

  return (
    <div className="my-10" data-mixpanel-area="Film Quote Slider">
      <div className="bg-bg-low text-fg p-5 touch-pan-y" {...swipe()}>
        <div className="relative">
          <div className="flex w-full relative pointer-events-none opacity-0 select-none overflow-hidden" aria-hidden>
            {slides}
          </div>
          <AnimatePresence mode="wait">
            <motion.div
              key={slider.current}
              initial="exit"
              animate="enter"
              exit="exit"
              // initial={{ opacity: 0, scale: 0.9 }}
              // animate={{ opacity: 1, scale: 1, transition: { delay: 0.2 } }}
              // exit={{ opacity: 0, scale: 0.9 }}
              className="absolute inset-0 flex items-top"
              transition={{ duration: 0.2, staggerChildren: 0.05 }}
            >
              {slides[slider.current]}
            </motion.div>
          </AnimatePresence>
        </div>
        {slider.total > 1 && (
          <div className="h-[8px] mt-4 relative">
            <div className="absolute bottom-0 left-0">
              <SlideTimerIndicator timer={slider} />
            </div>
          </div>
        )}
      </div>
    </div>
  )
})
